var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRamiUsoHiloSisalArtesalaDecorativo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#F57E25;}\n\t.st2{opacity:0.9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,19c0.7,0.7,1.7,1.1,3,1.1c1.3,0,2.2-0.4,3-1.1c0.7-0.7,1.1-1.7,1.1-2.9V6.8h3.2v9.3 c0,1.4-0.3,2.6-0.9,3.6c-0.6,1-1.4,1.8-2.5,2.3c-1.1,0.5-2.4,0.8-3.8,0.8c-1.5,0-2.8-0.3-3.9-0.8s-1.9-1.3-2.5-2.3 c-0.6-1-0.9-2.2-0.9-3.6V6.8h3.2v9.3C138.1,17.3,138.4,18.3,139.2,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161,9.7c-0.9-0.3-1.7-0.4-2.4-0.4c-0.8,0-1.4,0.1-1.8,0.4c-0.4,0.3-0.7,0.6-0.7,1.1c0,0.4,0.2,0.8,0.5,1.1 c0.3,0.3,0.7,0.5,1.2,0.7c0.5,0.2,1.1,0.4,1.9,0.6c1.1,0.3,2.1,0.6,2.8,1c0.7,0.3,1.3,0.8,1.8,1.4s0.8,1.4,0.8,2.4 c0,1-0.3,1.8-0.8,2.5s-1.3,1.3-2.3,1.6c-1,0.4-2.1,0.6-3.3,0.6c-1.3,0-2.6-0.2-3.8-0.7c-1.2-0.5-2.3-1.1-3.2-1.8l1.3-2.6 c0.8,0.7,1.8,1.3,2.8,1.7s2,0.6,2.9,0.6c0.9,0,1.6-0.2,2.1-0.5c0.5-0.3,0.8-0.8,0.8-1.3c0-0.5-0.2-0.8-0.5-1.1 c-0.3-0.3-0.7-0.5-1.2-0.7c-0.5-0.2-1.1-0.4-2-0.6c-1.1-0.3-2-0.6-2.8-0.9c-0.7-0.3-1.3-0.8-1.8-1.4c-0.5-0.6-0.8-1.4-0.8-2.4 c0-0.9,0.3-1.7,0.8-2.4c0.5-0.7,1.2-1.2,2.2-1.6c0.9-0.4,2-0.6,3.3-0.6c1.1,0,2.1,0.2,3.2,0.5c1.1,0.3,2,0.7,2.8,1.2l-1.3,2.7 C162.8,10.3,161.9,9.9,161,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.2,7.6c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9s2.9-1.1,4.5-1.1C177.4,6.5,178.9,6.9,180.2,7.6z M172.9,10c-0.9,0.5-1.6,1.1-2.1,1.9 c-0.5,0.8-0.8,1.7-0.8,2.7s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2 s0.8-1.7,0.8-2.7s-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9s-1.8-0.7-2.8-0.7C174.7,9.3,173.8,9.5,172.9,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.5,22.6l-1.5-3.4h-8.1l-1.5,3.4h-3.3l7.3-15.9h3.3l7.2,15.9H205.5z M197.1,16.7h5.9L200,10L197.1,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.4,22.6l-2.9-4.7c-0.1,0-0.3,0-0.6,0h-3.8v4.7H211V6.8h7c2.2,0,3.8,0.5,5,1.4c1.2,1,1.8,2.3,1.8,4 c0,1.2-0.3,2.3-0.8,3.2c-0.6,0.9-1.4,1.5-2.5,2l3.7,5.3H221.4z M214.2,15.3h3.8c1.2,0,2.1-0.2,2.8-0.7c0.6-0.5,1-1.2,1-2.2 c0-1-0.3-1.7-1-2.2c-0.6-0.5-1.6-0.7-2.8-0.7h-3.8V15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.4,6.8h13.6v2.7h-5.2v13.2h-3.2V9.4h-5.2V6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.2,6.8h12.2v2.7h-9v3.9h8.1V16h-8.1v4h9.3v2.7h-12.5V6.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.8,9.7c-0.9-0.3-1.7-0.4-2.4-0.4c-0.8,0-1.4,0.1-1.8,0.4c-0.4,0.3-0.7,0.6-0.7,1.1 c0,0.4,0.2,0.8,0.5,1.1c0.3,0.3,0.7,0.5,1.2,0.7c0.5,0.2,1.1,0.4,1.9,0.6c1.1,0.3,2.1,0.6,2.8,1c0.7,0.3,1.3,0.8,1.8,1.4 s0.8,1.4,0.8,2.4c0,1-0.3,1.8-0.8,2.5s-1.3,1.3-2.3,1.6c-1,0.4-2.1,0.6-3.3,0.6c-1.3,0-2.6-0.2-3.8-0.7c-1.2-0.5-2.3-1.1-3.2-1.8 l1.3-2.6c0.8,0.7,1.8,1.3,2.8,1.7s2,0.6,2.9,0.6c0.9,0,1.6-0.2,2.1-0.5c0.5-0.3,0.8-0.8,0.8-1.3c0-0.5-0.2-0.8-0.5-1.1 c-0.3-0.3-0.7-0.5-1.2-0.7c-0.5-0.2-1.1-0.4-2-0.6c-1.1-0.3-2-0.6-2.8-0.9c-0.7-0.3-1.3-0.8-1.8-1.4c-0.5-0.6-0.8-1.4-0.8-2.4 c0-0.9,0.3-1.7,0.8-2.4c0.5-0.7,1.2-1.2,2.2-1.6c0.9-0.4,2-0.6,3.3-0.6c1.1,0,2.1,0.2,3.2,0.5c1.1,0.3,2,0.7,2.8,1.2l-1.3,2.7 C267.5,10.3,266.7,9.9,265.8,9.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.1,22.6l-1.5-3.4h-8.1l-1.5,3.4h-3.3L278,6.8h3.3l7.2,15.9H285.1z M276.6,16.7h5.9l-2.9-6.7L276.6,16.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.1,6.8h3.1v15.9h-3l-8.6-10.9v10.9h-3.1V6.8h3l8.6,10.9V6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.7,22.6l-1.5-3.4H312l-1.5,3.4h-3.3l7.3-15.9h3.3l7.2,15.9H321.7z M313.2,16.7h5.9l-2.9-6.7L313.2,16.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.1,6.8h3.2v13.1h7.2v2.7h-10.4V6.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.6,28.9l-6.1,10.7v5.2h-3.2v-5.1l-6.2-10.8h3.2l4.5,7.5l4.5-7.5H148.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.9,29.9c1.3,0.7,2.3,1.6,3.1,2.8c0.7,1.2,1.1,2.6,1.1,4.1c0,1.5-0.4,2.9-1.1,4.1 c-0.8,1.2-1.8,2.1-3.1,2.8c-1.3,0.7-2.8,1-4.5,1h-6.8V28.9h6.9C165.1,28.9,166.6,29.2,167.9,29.9z M166.2,41.4 c0.8-0.4,1.5-1.1,1.9-1.9c0.5-0.8,0.7-1.7,0.7-2.7c0-1-0.2-1.9-0.7-2.7s-1.1-1.4-2-1.9c-0.8-0.4-1.8-0.7-2.8-0.7h-3.7V42h3.8 C164.5,42,165.4,41.8,166.2,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.9,28.9h12.2v2.7h-9v3.9h8.1v2.7h-8.1v4h9.3v2.7h-12.5V28.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.6,31.9c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7s-1.5,1.1-2,1.9c-0.5,0.8-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7c0.5,0.8,1.2,1.5,2,2s1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5c0.8-0.3,1.5-0.8,2.1-1.4l1.9,2 c-0.9,0.8-1.9,1.5-3,2c-1.2,0.5-2.3,0.7-3.5,0.7c-1.6,0-3.1-0.4-4.4-1.1s-2.4-1.7-3.1-3c-0.8-1.2-1.1-2.6-1.1-4.1 s0.4-2.9,1.2-4.1c0.8-1.2,1.8-2.2,3.2-2.9c1.3-0.7,2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7c1.1,0.5,2.1,1.1,2.9,1.9l-1.9,2.2 C202.1,32.8,201.4,32.3,200.6,31.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.9,29.7c1.4,0.7,2.4,1.7,3.2,2.9s1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 s-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1s-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1c0.8-1.2,1.8-2.2,3.2-2.9 c1.4-0.7,2.9-1.1,4.5-1.1C216,28.6,217.5,29,218.9,29.7z M211.6,32.1c-0.9,0.5-1.6,1.1-2.1,2c-0.5,0.8-0.8,1.7-0.8,2.7 s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2s0.8-1.7,0.8-2.7 s-0.2-1.9-0.8-2.7c-0.5-0.8-1.2-1.5-2-2c-0.9-0.5-1.8-0.7-2.8-0.7C213.4,31.4,212.5,31.6,211.6,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.5,44.7l-2.9-4.7c-0.1,0-0.3,0-0.6,0h-3.8v4.7h-3.2V28.9h7c2.2,0,3.8,0.5,5,1.4c1.2,1,1.8,2.3,1.8,4 c0,1.2-0.3,2.3-0.8,3.2c-0.6,0.9-1.4,1.5-2.5,2l3.7,5.3H236.5z M229.3,37.4h3.8c1.2,0,2.1-0.2,2.8-0.7c0.6-0.5,1-1.2,1-2.2 c0-1-0.3-1.7-1-2.2c-0.6-0.5-1.6-0.7-2.8-0.7h-3.8V37.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.6,44.7l-1.5-3.4H246l-1.5,3.4h-3.3l7.3-15.9h3.3l7.2,15.9H255.6z M247.1,38.8h5.9l-2.9-6.7L247.1,38.8z "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.5,28.9h13.6v2.7h-5.2v13.2h-3.2V31.5h-5.2V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.4,28.9h3.2v15.9h-3.2V28.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.6,28.9h3.4l4.9,12.5l5-12.5h3.3l-6.7,15.9h-3.3L278.6,28.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.1,29.7c1.4,0.7,2.4,1.7,3.2,2.9s1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1s-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9c1.4-0.7,2.9-1.1,4.5-1.1S307.7,29,309.1,29.7z M301.8,32.1c-0.9,0.5-1.6,1.1-2.1,2 c-0.5,0.8-0.8,1.7-0.8,2.7s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2 s0.8-1.7,0.8-2.7s-0.2-1.9-0.8-2.7c-0.5-0.8-1.2-1.5-2-2s-1.8-0.7-2.8-0.7C303.6,31.4,302.7,31.6,301.8,32.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "31,36.6 36.5,43.8 46.1,30.6 53.5,30.6 53.5,5.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2,
    y: 5.6,
    className: "st1",
    width: 8.8,
    height: 38.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 5.6,
    className: "st1",
    width: 8.8,
    height: 38.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "78.5,44.3 69.6,44.3 69.6,11.4 78.5,20.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96.1,44.3 104.9,44.3 104.9,11.4 96.2,20.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "69.6,5.6 79.4,5.6 87.1,15.3 95.4,5.6 104.9,5.6 104.9,9 87.1,27 69.6,9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,14.9L35.2,44H23.9L4,18.5v-13h18.5c0,0,10,0.5,10.9,12.5c0,0,0.6,8.9-6.8,12.3l-6.4-8.2 c0,0,3.5,0.6,3.5-3.5c0,0,0-3.6-3.3-3.7L12.9,14.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3.9,20.5 12.9,32 12.9,44.1 4,44.1  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3.9,20.8 13,32.4 13,44.5 4,44.5  "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamiUsoHiloSisalArtesalaDecorativo);
export default __webpack_public_path__ + "static/media/rami-uso-hilo-sisal-artesala-decorativo.fcdc1d81bfa4fa1036fe4e734b93f973.svg";
export { ForwardRef as ReactComponent };